import { styled } from '@mui/material/styles';
import { Container } from '@mui/material';
import { Document } from '@contentful/rich-text-types';
import { ICeRichTextFields } from 'types/generated/contentful';

import { RichTextContent } from './RichTextContent';
import { Options } from '@contentful/rich-text-react-renderer';

const RichTextBlockWrapper = styled('div')({
  whiteSpace: 'pre-wrap',
  marginTop: '1rem',
  marginBottom: '1rem',
});

interface RichTextBlockProps {
  document?: Document;
  options?: Options;
  bulletPointColor?: ICeRichTextFields['bulletPointColor'];
}

export const RichTextBlock = (props: RichTextBlockProps) => {
  const { document, options, bulletPointColor } = props;

  return (
    <Container>
      <RichTextBlockWrapper>
        <RichTextContent
          document={document}
          options={options}
          bulletPointColor={bulletPointColor}
        ></RichTextContent>
      </RichTextBlockWrapper>
    </Container>
  );
};
